import React from "react";
import {
  letterDict,
  chunkArray,
  boundariedChunkedArray,
} from "Components/AutoCompleteList";

import { state } from "State";
import { communityValues, geoAggregations } from "Data";

const selectFromState = ({ domain_data, ui }) => ({
  collection: (
    communityValues[domain_data.year][domain_data.community] || []
  ).filter(
    (name) =>
      name.toLowerCase().indexOf(ui.community_search_input.toLowerCase()) !== -1
  ),
});

// Display
const PrimarySearchMenu = ({ hidden, tree }) =>
  selectFromState(tree).chain(({ collection }) => (
    <div
      style={{ overflowY: "scroll", height: "90vh" }}
      hidden={hidden}
      id="primary-search-menu"
      className="fade white"
    >
      {letterDict(
        collection,
        (
          value // callback to set value on selection
        ) =>
          state.select("ui").merge({ community_search_input: value }) &&
          state.select("domain_data").merge({ community_value: value })
      )
        .chain((col) => boundariedChunkedArray(5)(col))
        .map((col, index) => (
          <div key={index} className="col-md-3 col-sm-4">
            {col}
          </div>
        ))}
    </div>
  ));

export default PrimarySearchMenu;



// WEBPACK FOOTER //
// ./components/PrimarySearchMenu.js